import { render, staticRenderFns } from "./rc-in-app-notice-dialog.vue?vue&type=template&id=0cd9909c&scoped=true&"
import script from "./rc-in-app-notice-dialog.vue?vue&type=script&lang=js&"
export * from "./rc-in-app-notice-dialog.vue?vue&type=script&lang=js&"
import style0 from "./rc-in-app-notice-dialog.vue?vue&type=style&index=0&id=0cd9909c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd9909c",
  null
  
)

export default component.exports